import type { PwaView, SubjectPack } from "../ai_literacy/subjectPack.js";
import { buildNotanyGraph, NOTANY_NODE_IDS } from "./curriculum.js";
import {
  COPY,
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
  getCopy,
  type Locale,
  type LocaleStrings,
  type StemTemplate,
} from "./conceptCopy.js";
import { NOTANY_SEED_QUESTIONS } from "./seed.js";
import { NOTANY_BACKPACK_DECK } from "./decks/backpack.js";
import { NOTANY_SPOTLIE_DECK } from "./decks/spotlie.js";
import { NOTANY_REDACT_DECK } from "./decks/redact.js";
import { NOTANY_BACKPACK_DECK_EL } from "./decks/backpackLocaleEl.js";
import { NOTANY_SPOTLIE_DECK_EL } from "./decks/spotlieLocaleEl.js";
import { NOTANY_REDACT_DECK_EL } from "./decks/redactLocaleEl.js";
import { applyNotanySeedLocale } from "./applySeedLocale.js";

function recommendViewForNotany(conceptId: string | null): PwaView | null {
  if (!conceptId) return null;
  if (conceptId === "self_hosted" || conceptId === "privacy_first") return "redact";
  if (conceptId === "your_content" || conceptId === "open_no_lockin") return "backpack";
  if (
    conceptId === "adaptive_core" ||
    conceptId === "measured_proof" ||
    conceptId === "engagement_loop"
  ) {
    return "spotlie";
  }
  return "mcq";
}

/**
 * Meta / pitch pack: the curriculum is notanyai's own benefits, so the demo *is* the
 * proof — you learn what the platform does by playing a course built on it. Also the
 * clearest illustration that companies can author their own pool of trainings/tests.
 */
export const NOTANY_PACK: SubjectPack = {
  id: "notany",
  buildGraph: buildNotanyGraph,
  conceptIds: NOTANY_NODE_IDS,
  copy: COPY,
  getCopy,
  defaultLocale: DEFAULT_LOCALE,
  supportedLocales: SUPPORTED_LOCALES,
  seedQuestions: NOTANY_SEED_QUESTIONS,
  applySeedLocale: applyNotanySeedLocale,
  recommendViewForConcept: recommendViewForNotany,
  quest: {
    id: "tour",
    steps: [
      { conceptId: "adaptive_core", minElo: 1200 },
      { conceptId: "your_content", minElo: 1250 },
      { conceptId: "self_hosted", minElo: 1280 },
      { conceptId: "measured_proof", minElo: 1300 },
    ],
  },
  decks: {
    backpack: NOTANY_BACKPACK_DECK,
    spotlie: NOTANY_SPOTLIE_DECK,
    redact: NOTANY_REDACT_DECK,
  },
  localizeDecks: (locale) => {
    if (locale !== "el") {
      return {
        backpack: NOTANY_BACKPACK_DECK,
        spotlie: NOTANY_SPOTLIE_DECK,
        redact: NOTANY_REDACT_DECK,
      };
    }
    return {
      backpack: NOTANY_BACKPACK_DECK_EL,
      spotlie: NOTANY_SPOTLIE_DECK_EL,
      redact: NOTANY_REDACT_DECK_EL,
    };
  },
};

export type { Locale, LocaleStrings, StemTemplate };
